export const moduleName = "content";

export type ContentTabs = "ACTIONS" | "SECTIONS" | "CAMPAIGNS";

export type ContentState = {
	activeTab: ContentTabs;
};
